module.exports = __webpack_public_path__ + "static/media/city7.30c24ad5.jpg";